

const callbackListenerKey = function (e) {
    this.pressedKey = e.key;
}

const listenerKeyPressed = function () {
    addEventListener("keydown", this.callbackListenerKey);
}

const keySelected = function (key) {
    this.permission = {...this["auth/getUser"]}
    if (key == "F2") {
        this.openCashierDialog()
        this.pressedKey = undefined;
    } else if (key == "F4") {
        this.openBleedDialog()
        this.pressedKey = undefined;
    } else if (key == "F6") {
        this.openSupplyDialog()
        this.pressedKey = undefined;
    } else if (key == "F8") {
        this.openCloseCashierDialog()
        this.pressedKey = undefined;
    } else if (key == "F9") {
        this.pressedKey = undefined;
    } else if (key == 'F10'){
        this.$store.dispatch('setShowDialogRegisterExchangeControl', true)
        this.pressedKey = undefined;
    }
}

module.exports = {
    listenerKeyPressed,
    callbackListenerKey,
    keySelected
}